import React, {
  useState,
  useMemo,
  useEffect,
  useRef,
  useCallback,
} from "react";
import styles from "./Home.module.css";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import games from "../../utils/games";
import Login from "../../Components/Login/Login";
import Sidebar from "../../Components/Sidebar/Sidebar";
import Collections from "../../Components/Collections/Collections";
import Topics from "../../Components/Topic/Topics";
import { post, get } from "../../utils/request";
import { getFilePreviewUrl } from "../../utils/attachmentPreview";
import DownloadProgress from "../../Components/DownloadProgress/DownloadProgress";
import AppDownloadModal from "../../Components/AppDownloadModal/AppDownloadModal";
import { useAppDownload } from "../../hooks/useAppDownload";
import { getCurrentUserAvatarUrl } from "../../utils/userAvatar";
import { useToast } from "../../Components/Toast/Toast";
import { t } from "../../utils/i18n";
import { stripHtml } from "../../utils/stripHtml";
import { GameeBrand, TextWithGameeBrand } from "../../utils/brand";
import {
  gameHomePath,
  gameDetailPath,
  collectionDetailPath,
  topicDetailPath,
  isCollectionsListPath,
  isTopicsListPath,
} from "../../utils/routes";

const TRENDING_PAGE_SIZE = 9;

// 实际的 API 请求将在组件内调用，以获取分类等状态

const MOBILE_BREAKPOINT = 499;

const SIDEBAR_ITEMS = [
  { id: "featured", label: "Featured", icon: "controller" },
  { id: "editors", label: "Editor's Choice", icon: "star" },
  { id: "strategy", label: "Strategy", icon: "zap" },
  { id: "casual", label: "Casual", icon: "coffee" },
  { id: "action", label: "Action", icon: "sword" },
  { id: "sports", label: "Sports", icon: "trophy" },
  { id: "racing", label: "Racing", icon: "flag" },
  { id: "offline", label: "Offline", icon: "wifi-off" },
];

// const SIDEBAR_ICONS = {
//   controller: (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <path d="M6 12h12M6 16h12M6 8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2z" />
//       <rect x="2" y="12" width="20" height="10" rx="2" />
//     </svg>
//   ),
//   star: (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
//     </svg>
//   ),
//   zap: (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
//     </svg>
//   ),
//   coffee: (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
//       <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
//       <line x1="6" y1="1" x2="6" y2="4" />
//       <line x1="10" y1="1" x2="10" y2="4" />
//       <line x1="14" y1="1" x2="14" y2="4" />
//     </svg>
//   ),
//   sword: (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <polyline points="14.5 17.5 3 6 3 3 6 3 17.5 14.5" />
//       <line x1="13" y1="19" x2="19" y2="13" />
//       <line x1="16" y1="16" x2="20" y2="20" />
//       <line x1="19" y1="21" x2="21" y2="19" />
//     </svg>
//   ),
//   trophy: (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
//       <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
//       <path d="M4 22h16" />
//       <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
//       <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
//       <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
//     </svg>
//   ),
//   flag: (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
//       <line x1="4" y1="22" x2="4" y2="15" />
//     </svg>
//   ),
//   "wifi-off": (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//     >
//       <line x1="1" y1="1" x2="23" y2="23" />
//       <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
//       <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
//       <path d="M10.71 5.05A16 16 0 0 1 22.58 9" />
//       <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
//       <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
//       <line x1="12" y1="20" x2="12.01" y2="20" />
//     </svg>
//   ),
// };

const Home = props => {
  const toast = useToast();
  const {
    cartDisplayed,
    isOverlayOpen = false,
    handleCloseCart,
    handleOpenLogin,
    handleLoginSuccess,
    handleLogout,
    handleOpenProfile,
    isLoggedIn,
    openGamePage,
    theme,
    setTheme,
  } = props;

  /* Categories State - 首页分类状态 */
  const [categories, setCategories] = useState([]);
  const [searchParams] = useSearchParams();
  // 从 URL ?category=xxx 读取初始分类（从详情页跳回时携带）
  const [activeCategory, setActiveCategory] = useState(() =>
    decodeURIComponent(searchParams.get("category") || ""),
  );
  const categoriesFetchedRef = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();

  // URL 携带 category 参数时，初始化后立即清理 URL（避免刷新重复应用）
  useEffect(() => {
    if (searchParams.get("category")) {
      navigate(gameHomePath({ category: searchParams.get("category") }), {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 通过路径判断当前子页面
  const isCollectionsPage = isCollectionsListPath(location.pathname);
  const isTopicsPage = isTopicsListPath(location.pathname);

  useEffect(() => {
    if (categoriesFetchedRef.current) return;
    categoriesFetchedRef.current = true;
    post("/game/category/category-info", {})
      .then(res => {
        const list = res?.data ?? [];
        setCategories(Array.isArray(list) ? list : []);
      })
      .catch(err => {
        console.warn("获取分类失败:", err);
      });
  }, []);

  /* 移动端状态 */
  const SIDEBAR_OPEN_KEY = "mg_sidebar_open";
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(() => {
    try {
      return sessionStorage.getItem(SIDEBAR_OPEN_KEY) === "true";
    } catch (e) {
      return false;
    }
  });
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  // 搜索类型：1-游戏，2-话题，4-合集
  const [searchType, setSearchType] = useState("1");
  // 合集列表页的搜索关键词，提交后才生效
  const [collectionSearchKeyword, setCollectionSearchKeyword] = useState("");
  // 搜索联想列表（/api/game/search/list 返回的 searchList）
  const [searchList, setSearchList] = useState([]);
  const [searchListType, setSearchListType] = useState("");
  const [searchListLoading, setSearchListLoading] = useState(false);
  const [searchDropdownVisible, setSearchDropdownVisible] = useState(false);
  const [searchEmptyHintVisible, setSearchEmptyHintVisible] = useState(false);
  const searchWrapperRef = useRef(null);
  const searchListRequestIdRef = useRef(0);
  const searchDebounceRef = useRef(null);
  const [trendingDisplayCount, setTrendingDisplayCount] =
    useState(TRENDING_PAGE_SIZE);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [userAvatarUrl, setUserAvatarUrl] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const [activeNotification, setActiveNotification] = useState(null);
  const trendingSentinelRef = useRef(null);
  const userMenuRef = useRef(null);
  const bellRef = useRef(null);

  useEffect(() => {
    try {
      sessionStorage.setItem(SIDEBAR_OPEN_KEY, String(isMobileMenuOpen));
    } catch (e) {
      // ignore
    }
  }, [isMobileMenuOpen]);

  // 根据类型和 objectId 得到详情页路径：1-游戏 2-话题 4-合集
  const getSearchDetailPath = useCallback((type, objectId) => {
    if (!objectId) return "";
    const t = String(type);
    if (t === "1") return gameDetailPath(objectId);
    if (t === "2") return topicDetailPath(objectId);
    if (t === "4") return collectionDetailPath(objectId);
    return "";
  }, []);

  // 请求搜索联想列表，返回 { list, type } 供提交时判断是否直接跳转
  const fetchSearchList = useCallback(
    async (name, type) => {
      const reqId = searchListRequestIdRef.current + 1;
      searchListRequestIdRef.current = reqId;
      setSearchListLoading(true);
      try {
        const res = await post("/game/search/list", {
          name: name ?? "",
          type: type ?? searchType,
        });
        if (searchListRequestIdRef.current !== reqId) return { list: [], type: "" };
        const data = res?.data ?? res;
        const list = Array.isArray(data?.searchList) ? data.searchList : [];
        const resType = data?.type != null ? String(data.type) : searchType;
        setSearchList(list);
        setSearchListType(resType);
        setSearchEmptyHintVisible(false);
        setSearchDropdownVisible(list.length > 0);
        return { list, type: resType };
      } catch (err) {
        if (searchListRequestIdRef.current !== reqId) return { list: [], type: "" };
        setSearchList([]);
        setSearchEmptyHintVisible(false);
        setSearchDropdownVisible(false);
        return { list: [], type: "" };
      } finally {
        if (searchListRequestIdRef.current === reqId) setSearchListLoading(false);
      }
    },
    [searchType],
  );

  // 输入关键词时防抖请求联想列表
  useEffect(() => {
    const keyword = searchInput.trim();
    if (!keyword) {
      setSearchList([]);
      setSearchEmptyHintVisible(false);
      setSearchDropdownVisible(false);
      return;
    }
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      fetchSearchList(keyword, searchType);
    }, 300);
    return () => {
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    };
  }, [searchInput, searchType, fetchSearchList]);

  useEffect(() => {
    const handleClickOutside = e => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setShowUserMenu(false);
      }
      if (bellRef.current && !bellRef.current.contains(e.target)) {
        setShowNotifications(false);
      }
      if (searchWrapperRef.current && !searchWrapperRef.current.contains(e.target)) {
        setSearchEmptyHintVisible(false);
        setSearchDropdownVisible(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    let cancelled = false;

    const fetchUserAvatar = async () => {
      if (!isLoggedIn) {
        setUserAvatarUrl("");
        return;
      }
      try {
        const url = await getCurrentUserAvatarUrl();
        if (!cancelled) setUserAvatarUrl(url || "");
      } catch (e) {
        if (!cancelled) setUserAvatarUrl("");
      }
    };

    fetchUserAvatar();
    return () => {
      cancelled = true;
    };
  }, [isLoggedIn]);

  const fetchNotifications = useCallback(async () => {
    setLoadingNotifications(true);
    try {
      const res = await get("/user/message/list");
      const list = Array.isArray(res?.data) ? res.data : [];
      setNotifications(list);
    } catch (e) {
      console.warn("获取消息列表失败:", e);
      setNotifications([]);
    } finally {
      setLoadingNotifications(false);
    }
  }, []);

  const {
    openDownloadModal,
    closeDownloadModal,
    startDownload,
    modalOpen,
    modalInfo,
    minimizeDownload,
    expandDownload,
    progress: downloadProgress,
    downloading: downloadLoading,
  } = useAppDownload({ toast });

  const [featuredGames, setFeaturedGames] = useState([]);
  const [activeGameId, setActiveGameId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchFeaturedGames = async () => {
      try {
        const res = await post("/game/game-choiceness", {});
        const list = Array.isArray(res?.data) ? res.data : [];

        // 先快速渲染基础数据，再后台异步补图，提升首屏速度
        const mapped = list.slice(0, 10).map(item => {
          const rating = Number(item.gameRating) || 0;
          return {
            // 使用后端返回的 id 作为唯一标识
            id: item.id,
            name: item.gameName || "",
            cover: "",
            // 游戏简介：后端通常返回 introText
            description: item.introText || "",
            genre: item.categoryName || "",
            rating,
            // 封面图：优先 attachmentUuid，其次兼容 gameIconId
            iconId: item.attachmentUuid || item.gameIconId || "",
          };
        });
        if (!cancelled) {
          if (mapped.length > 0) {
            setFeaturedGames(mapped);
            setActiveGameId(prev => prev || mapped[0].id);

            // 异步为每个精选游戏补充封面图
            mapped.forEach(game => {
              if (!game.iconId) return;
              getFilePreviewUrl(game.iconId)
                .then(url => {
                  if (!url) return;
                  if (cancelled) return;
                  setFeaturedGames(prev =>
                    prev.map(g =>
                      g.id === game.id ? { ...g, cover: url } : g,
                    ),
                  );
                })
                .catch(() => {});
            });
          } else {
            // 后端无数据时回退到本地前 5 条
            const fallback = games.slice(0, 5);
            setFeaturedGames(fallback);
            if (fallback.length > 0) setActiveGameId(fallback[0].id);
          }
        }
      } catch (err) {
        console.warn("获取精选游戏失败:", err);
        if (!cancelled) {
          const fallback = games.slice(0, 5);
          setFeaturedGames(fallback);
          if (fallback.length > 0) setActiveGameId(fallback[0].id);
        }
      }
    };
    fetchFeaturedGames();
    return () => {
      cancelled = true;
    };
  }, []);

  const activeGame = useMemo(() => {
    if (!featuredGames.length) return null;
    return featuredGames.find(g => g.id === activeGameId) || featuredGames[0];
  }, [featuredGames, activeGameId]);

  /* Mobile/Small Screen State (<= 699px) */
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 699);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 699);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* Auto-play Carousel Logic */
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    // Disable auto-play on small screens where we use horizontal scroll
    if (featuredGames.length === 0 || isPaused || isSmallScreen || isOverlayOpen)
      return;

    const interval = setInterval(() => {
      setActiveGameId(currentId => {
        const currentIndex = featuredGames.findIndex(g => g.id === currentId);
        const nextIndex = (currentIndex + 1) % featuredGames.length;
        return featuredGames[nextIndex].id;
      });
    }, 5000); // 5 seconds interval

    return () => clearInterval(interval);
  }, [featuredGames, isPaused, isSmallScreen, isOverlayOpen]);

  /* Trending Games - 无限滚动状态 */
  const [trendingGames, setTrendingGames] = useState([]);
  const [trendingPage, setTrendingPage] = useState(1);
  const [trendingLoading, setTrendingLoading] = useState(false);
  const [trendingHasMore, setTrendingHasMore] = useState(true);
  const [trendingError, setTrendingError] = useState(false);
  /** 第一页请求结束后为 true，避免首屏尚未请求时误显示「无数据」占位 */
  const [trendingListSettled, setTrendingListSettled] = useState(false);
  const contentRef = useRef(null);

  // 动态加载趋势游戏
  const loadMoreTrendingGames = useCallback(
    async (pageNum, currentCategory = activeCategory) => {
      if (pageNum > 1 && (trendingLoading || !trendingHasMore)) return;
      if (pageNum === 1) {
        setTrendingError(false);
        setTrendingListSettled(false);
      }
      setTrendingLoading(true);
      try {
        const reqBody = {
          data: {
            categoryId: currentCategory === "all" ? "" : currentCategory,
          },
          pageNo: pageNum,
          pageSize: TRENDING_PAGE_SIZE,
        };
        const res = await post("/game/game-list", reqBody);

        let pageGames = [];
        let hasMore = false;

        // request.js 已经解构了顶层包装，这里的 res 本身往往就已经是业务对象，即包含 data/total/pageNo 的对象
        // 防止后端封装层级不同，支持 res.data 是数组 或 res.data.data 是数组
        const resData = res?.data?.data ? res.data : res;

          if (resData && Array.isArray(resData.data)) {
          // 先映射当前页基础数据，再异步补图
          pageGames = resData.data.map(item => {
            const rating = Number(item.gameRating) || 0;
            return {
              // id 仅使用 /api/game/game-list 返回的 id
              id: item.id,
              name: item.gameName || "",
              cover: "",
              description: item.introText || "",
              topComment: item.topComment || "",
              genre: item.categoryName || "",
              rating,
              downloadNum: item.downloadNum || 0,
              // 封面图：优先 attachmentUuid，其次兼容 gameIconId
              iconId: item.attachmentUuid || item.gameIconId || "",
            };
          });

          const total = resData.total || 0;
          hasMore = pageNum * TRENDING_PAGE_SIZE < total;
        }

        // 先更新列表，优先保证文本和骨架渲染出来
        setTrendingGames(prev =>
          pageNum === 1 ? pageGames : [...prev, ...pageGames],
        );
        setTrendingHasMore(hasMore);
        setTrendingPage(pageNum);

        // 异步为当前页的游戏补充封面图（仅针对有 iconId 的）
        if (pageGames.length > 0) {
          pageGames.forEach(game => {
            if (!game.iconId) return;
            getFilePreviewUrl(game.iconId)
              .then(url => {
                if (!url) return;
                setTrendingGames(prev =>
                  prev.map(g =>
                    g.id === game.id ? { ...g, cover: url } : g,
                  ),
                );
              })
              .catch(() => {});
          });
        }
      } catch (error) {
        console.error("加载列表失败:", error);
        if (pageNum === 1) {
          setTrendingError(true);
          setTrendingGames([]);
          setTrendingHasMore(false);
        }
      } finally {
        setTrendingLoading(false);
        if (pageNum === 1) {
          setTrendingListSettled(true);
        }
      }
    },
    [activeCategory, trendingLoading, trendingHasMore],
  );

  // 初始化或分类切换时重置并加载第一页（仅在首页主视图时生效）
  useEffect(() => {
    // 在合集页或话题页时，不加载游戏列表
    if (isCollectionsPage || isTopicsPage) return;
    // 强制重置状态以加载新分类的数据
    setTrendingPage(1);
    setTrendingHasMore(true);
    // 注意：利用传参的方式跳过 state 闭包延迟，强制取最新 category
    loadMoreTrendingGames(1, activeCategory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCategory, isCollectionsPage, isTopicsPage]);

  // 滚动检测 - 到底部时加载更多（仅在首页主视图时生效）
  useEffect(() => {
    // 在合集页或话题页时，不做游戏列表的滚动加载
    if (isCollectionsPage || isTopicsPage) return;

    const element = contentRef.current;
    // 如果主容器没有 ref 或没有独立滚动，则回退监听 window 滚动
    // 避免一次滚动触发多次 setState / 请求
    let rafId = null;
    const handleScroll = () => {
      if (rafId) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = null;

        const elementDistance = element
          ? element.scrollHeight - element.scrollTop - element.clientHeight
          : Number.POSITIVE_INFINITY;

        const windowDistance =
          document.documentElement.scrollHeight -
          document.documentElement.scrollTop -
          window.innerHeight;

        // 取更接近底部的距离，兼容两种滚动模式：main 容器滚动 / window 滚动
        const distanceToBottom = Math.min(elementDistance, windowDistance);

        // 距离底部100px时触发加载
        if (distanceToBottom < 100 && trendingHasMore && !trendingLoading) {
          loadMoreTrendingGames(trendingPage + 1);
        }
      });
    };

    if (element) {
      element.addEventListener("scroll", handleScroll, { passive: true });
    }
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      if (element) {
        element.removeEventListener("scroll", handleScroll);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, [
    trendingPage,
    trendingHasMore,
    trendingLoading,
    loadMoreTrendingGames,
    isCollectionsPage,
    isTopicsPage,
  ]);

  const handleSearchSubmit = async e => {
    e.preventDefault();
    const keyword = searchInput.trim();
    if (!keyword) return;
    if (isCollectionsPage) {
      setCollectionSearchKeyword(keyword);
      return;
    }
    const { list, type: resType } = await fetchSearchList(keyword, searchType);
    if (list.length === 0) {
      setSearchList([]);
      setSearchEmptyHintVisible(true);
      setSearchDropdownVisible(true);
      return;
    }
    setSearchEmptyHintVisible(false);
    if (list.length === 1) {
      const path = getSearchDetailPath(resType || searchType, list[0].objectId);
      if (path) {
        navigate(path);
        setSearchInput("");
        setSearchList([]);
        setSearchEmptyHintVisible(false);
        setSearchDropdownVisible(false);
        setIsMobileSearchOpen(false);
      }
      return;
    }
    setSearchDropdownVisible(true);
  };

  const handleSelectSearchItem = item => {
    const path = getSearchDetailPath(searchListType || searchType, item.objectId);
    if (path) {
      navigate(path);
      setSearchInput("");
      setSearchList([]);
      setSearchEmptyHintVisible(false);
      setSearchDropdownVisible(false);
      setIsMobileSearchOpen(false);
    }
  };

  const goToGame = game => {
    navigate(gameDetailPath(game.id));
  };

  // 评分直接使用接口返回的 gameRating（Number），这里只做一位小数格式化
  const formatRating = rating => (Number(rating) || 0).toFixed(1);

  return (
    <div className={styles.page}>
      {cartDisplayed ? (
        <Login
          cartDisplayed={cartDisplayed}
          handleCloseCart={handleCloseCart}
          onLoginSuccess={handleLoginSuccess}
        />
      ) : null}

      <div className={styles.container}>
        {/* 侧边栏组件 */}
        <Sidebar
          isOpen={isMobileMenuOpen}
          onClose={() => setIsMobileMenuOpen(false)}
          theme={theme}
          setTheme={setTheme}
          isLoggedIn={isLoggedIn}
          handleOpenLogin={handleOpenLogin}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
          categories={categories}
          onNavigate={navigate}
        />
        {/* Content Column: Header + Main */}
        <div className={styles.contentColumn}>
          {/* Header */}
          <header className={styles.header}>
            {/* Mobile Header Elements */}
            <div className={styles.mobileHeaderLeft}>
              <button
                className={styles.hamburgerBtn}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                aria-label={t("aria.menu", "Menu")}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
              <div
                className={styles.mobileTitle}
                onClick={() => {
                  setActiveCategory("");
                  navigate(gameHomePath());
                }}
              >
                <GameeBrand /> Store
              </div>
            </div>

            <div className={styles.mobileHeaderRight}>
              <button
                className={styles.mobileSearchBtn}
                onClick={() => setIsMobileSearchOpen(true)}
                aria-label={t("aria.search", "Search")}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.35-4.35" />
                </svg>
              </button>
              {/* Mobile Avatar / Login Placeholder */}
              <div className={styles.mobileAvatar}>
                {isLoggedIn ? (
                  <div className={styles.avatarPlaceholder}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                  </div>
                ) : (
                  <div
                    className={styles.avatarPlaceholder}
                    onClick={handleOpenLogin}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                  </div>
                )}
              </div>
            </div>

            <div className={styles.searchFormWrapper} ref={searchWrapperRef}>
              <form className={styles.searchForm} onSubmit={handleSearchSubmit}>
                <select
                  className={styles.searchTypeSelect}
                  value={searchType}
                  onChange={e => setSearchType(e.target.value)}
                  aria-label={t("home.search.type.aria", "Search Type (Games, Topics, Collections)")}
                >
                  <option value="1">{t("home.search.type.games", "Games")}</option>
                  <option value="2">{t("home.search.type.topics", "Topics")}</option>
                  <option value="4">{t("home.search.type.collections", "Collections")}</option>
                </select>
                <input
                  type="search"
                  placeholder={t("home.search.placeholder", "Games, Topics and Collections")}
                  value={searchInput}
                  onChange={e => {
                    const val = e.target.value;
                    setSearchInput(val);
                    if (!val && isCollectionsPage) setCollectionSearchKeyword("");
                  }}
                  onFocus={() => searchList.length > 0 && setSearchDropdownVisible(true)}
                  className={styles.searchInput}
                  aria-label={t("aria.search", "Search")}
                  aria-autocomplete="list"
                  aria-expanded={searchDropdownVisible}
                  aria-controls="search-listbox"
                  role="combobox"
                />
                <button
                  type="submit"
                  className={styles.searchIcon}
                  aria-label={t("aria.search", "Search")}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <circle cx="11" cy="11" r="8" />
                    <path d="m21 21-4.35-4.35" />
                  </svg>
                </button>
              </form>
              <AnimatePresence>
                {searchDropdownVisible &&
                  (searchList.length > 0 || searchListLoading || searchEmptyHintVisible) && (
                  <motion.ul
                    id="search-listbox"
                    className={styles.searchDropdown}
                    role="listbox"
                    initial={{ opacity: 0, y: -4 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -4 }}
                    transition={{ duration: 0.15 }}
                  >
                    {searchListLoading && searchList.length === 0 ? (
                      <li className={styles.searchDropdownItem}>
                        {t("home.search.searching", "Searching...")}
                      </li>
                    ) : searchList.length === 0 && searchEmptyHintVisible ? (
                      <li className={styles.searchDropdownItem}>
                        {t("home.search.noResult", "No results found")}
                      </li>
                    ) : (
                      searchList.map(item => (
                        <li key={item.objectId}>
                          <button
                            type="button"
                            className={styles.searchDropdownItem}
                            onClick={() => handleSelectSearchItem(item)}
                            role="option"
                          >
                            {item.objectName}
                          </button>
                        </li>
                      ))
                    )}
                  </motion.ul>
                )}
              </AnimatePresence>
            </div>
            <div className={styles.headerActions}>
              <button
                type="button"
                className={styles.btnDownload}
                aria-label={t("home.downloadApp")}
                aria-busy={downloadLoading}
                disabled={downloadLoading}
                onClick={openDownloadModal}
                onKeyDown={e => e.key === "Enter" && openDownloadModal()}
              >
                {downloadLoading
                  ? t("home.downloadApp.loading")
                  : t("home.downloadApp")}
              </button>
              {isLoggedIn && handleLogout ? (
                <div className={styles.userArea} ref={userMenuRef}>
                  <div
                    className={styles.avatarWrapper}
                    onClick={() => setShowUserMenu(!showUserMenu)}
                    aria-haspopup="true"
                    aria-expanded={showUserMenu}
                    role="button"
                    tabIndex={0}
                    onKeyDown={e =>
                      e.key === "Enter" && setShowUserMenu(v => !v)
                    }
                  >
                    <div className={styles.avatar} aria-label={t("aria.userMenu", "User menu")}>
                      {userAvatarUrl ? (
                        <img src={userAvatarUrl} alt="" />
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                          <circle cx="12" cy="7" r="4" />
                        </svg>
                      )}
                    </div>
                  </div>
                  <AnimatePresence>
                    {showUserMenu && (
                      <motion.div
                        className={styles.userMenu}
                        initial={{ opacity: 0, y: -8 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -8 }}
                        transition={{ duration: 0.15 }}
                      >
                        <button
                          type="button"
                          className={styles.menuItem}
                          onClick={() => {
                            handleOpenProfile?.();
                            setShowUserMenu(false);
                          }}
                        >
                          {t("home.menu.editProfile", "Edit personal information")}
                        </button>
                        <button
                          type="button"
                          className={styles.menuItem}
                          onClick={() => {
                            handleLogout();
                            setShowUserMenu(false);
                          }}
                        >
                          {t("home.menu.logout", "Log out")}
                        </button>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              ) : (
                <button
                  type="button"
                  className={styles.btnLogin}
                  onClick={() => handleOpenLogin?.()}
                  aria-label={t("home.loginCta", "Join for free or log in")}
                >
                  {t("home.loginCta", "Join for free or log in")}
                </button>
              )}
              {isLoggedIn && (
                <div className={styles.bellWrapper} ref={bellRef}>
                  <button
                    type="button"
                    className={styles.btnBell}
                    aria-label={t("aria.notifications", "Notifications")}
                    onClick={e => {
                      e.stopPropagation();
                      const next = !showNotifications;
                      setShowNotifications(next);
                      if (next && notifications.length === 0) {
                        fetchNotifications();
                      }
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
                      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                    </svg>
                  </button>
                  {showNotifications && (
                    <div className={styles.notificationPanel}>
                      <div className={styles.notificationHeader}>
                        {t("home.notifications.title", "Message Center")}
                      </div>
                      <div className={styles.notificationList}>
                        {loadingNotifications && (
                          <div className={styles.notificationEmpty}>
                            Loading...
                          </div>
                        )}
                        {!loadingNotifications &&
                          notifications.map((msg, idx) => (
                            <div
                              key={idx}
                              className={styles.notificationItem}
                              onClick={() => setActiveNotification(msg)}
                            >
                              <div className={styles.notificationTitle}>
                                {msg.title ||
                                  t("home.notifications.system", "System Notification")}
                              </div>
                              {msg.content && (
                                <div
                                  className={styles.notificationContent}
                                  dangerouslySetInnerHTML={{
                                    __html: String(msg.content),
                                  }}
                                />
                              )}
                              <div className={styles.notificationMeta}>
                                {msg.sendTime || ""}
                              </div>
                            </div>
                          ))}
                        {!loadingNotifications && notifications.length === 0 && (
                          <div className={styles.notificationEmpty}>
                            {t("home.notifications.empty", "No messages")}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </header>

          <main className={styles.main} ref={contentRef}>
            {/* 子路由视图：通过 URL 路径判断渲染合集/话题/首页内容 */}
            {isCollectionsPage ? (
              <Collections searchKeyword={collectionSearchKeyword} />
            ) : isTopicsPage ? (
              <Topics />
            ) : (
              <>
                {/* 当处于全部分类时，显示推介位（Featured Games）; 否则显示分类头部胶囊与介绍 */}
                {!activeCategory ? (
                  <section
                    className={styles.section}
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                  >
                    <div className={styles.sectionTitle}>
                      {t("home.featured.title", "Featured Games")}
                    </div>
                    <div className={styles.featuredGrid}>
                      {/* Hero Card (Active Item) */}
                      {activeGame && (
                        <div
                          className={styles.featuredHero}
                          onClick={() => goToGame(activeGame)}
                        >
                          {activeGame.cover && (
                            <img
                              src={activeGame.cover}
                              alt={activeGame.name}
                              className={styles.heroCover}
                            />
                          )}
                          <div className={styles.heroOverlay}>
                            <div className={styles.heroContent}>
                              <h3 className={styles.heroTitle}>
                                {activeGame.name}
                              </h3>
                              <p className={styles.heroDesc}>
                                {(activeGame.description || "").trim() ? (
                                  <span
                                    className={styles.heroDescHtml}
                                    dangerouslySetInnerHTML={{
                                      __html: String(activeGame.description).trim(),
                                    }}
                                  />
                                ) : null}
                              </p>
                              <div className={styles.heroRating}>
                                <span className={styles.ratingLabel}>
                                  <GameeBrand />
                                </span>
                                <span className={styles.ratingValue}>
                                  {formatRating(activeGame.rating)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Side List (All 5 Items) */}
                      <div className={styles.featuredList}>
                        {featuredGames.map(game => (
                          <div
                            key={game.id}
                            className={`${styles.featuredListItem} ${activeGameId === game.id ? styles.active : ""}`}
                            onMouseEnter={() => {
                              if (isSmallScreen) return;
                              setActiveGameId(game.id);
                            }}
                            onClick={() => goToGame(game)}
                          >
                            {game.cover ? (
                              <img
                                src={game.cover}
                                alt={game.name}
                                className={styles.listCover}
                              />
                            ) : (
                              <div className={styles.listCoverPlaceholder}>
                                {game.name?.charAt(0) || "G"}
                              </div>
                            )}
                            <div className={styles.listInfo}>
                              <div className={styles.listName}>{game.name}</div>
                              {/* Mobile Description (Hidden on desktop via CSS) */}
                              {(game.desc || game.description || "").trim() ? (
                                <span
                                  className={styles.listDescMobile}
                                  dangerouslySetInnerHTML={{
                                    __html: String(
                                      game.desc || game.description || "",
                                    ).trim(),
                                  }}
                                />
                              ) : null}
                              <div className={styles.listMeta}>
                                <div className={styles.listMetaTop}>
                                  <div className={styles.listRating}>
                                    <span className={styles.starIcon}>★</span>
                                    {formatRating(game.rating)}
                                    <span className={styles.platformIcons} aria-label={t("aria.platform", "Platform")}>
                                      <span className={styles.platformIcon} title="Android" aria-label={t("aria.android", "Android")}>
                                        <svg
                                          className={styles.platformSvg}
                                          viewBox="0 0 12 12"
                                          aria-hidden="true"
                                        >
                                          <path d="M2.834 3.875h6.214v4.781c0 .523-.28.799-.804.8H7.86c0 .553.006 1.091-.002 1.63a.652.652 0 0 1-.624.622c-.355.013-.68-.233-.692-.574-.02-.55-.006-1.103-.006-1.667h-1.19v.657c-.002.323.005.646-.006.969a.649.649 0 0 1-.566.612.664.664 0 0 1-.725-.454.737.737 0 0 1-.034-.213c-.003-.459-.002-.917-.001-1.376 0-.063.01-.126.018-.207h-.457c-.449-.003-.74-.294-.741-.744V3.876zm6.217-.458H2.83c.058-1.076.67-1.745 1.577-2.22L4.134.786 3.936.488c-.046-.07-.12-.15-.017-.22.11-.074.155.031.204.103.117.172.232.345.347.518.142.214.142.214.387.142a3.74 3.74 0 0 1 2.315.05c.028.01.056.017.092.028L7.738.4l.056-.084c.045-.064.101-.098.172-.046.064.048.053.108.013.169l-.41.614-.095.145c.904.47 1.52 1.14 1.577 2.22zm-1.446-1.21a.337.337 0 0 0-.33-.335.33.33 0 0 0-.333.329.324.324 0 0 0 .327.332.33.33 0 0 0 .336-.326zm-2.667-.008a.33.33 0 0 0-.335-.327.338.338 0 0 0-.327.337.331.331 0 0 0 .337.324.324.324 0 0 0 .325-.334zm5.884 3.76v1.387c-.002.407-.282.701-.664.7-.382 0-.665-.295-.665-.7 0-.938-.002-1.875 0-2.813a.655.655 0 0 1 .588-.657.658.658 0 0 1 .726.518c.014.066.014.135.014.203v1.362zm-8.437 0c0 .484.004.967-.002 1.451a.652.652 0 0 1-.497.619.649.649 0 0 1-.724-.297.755.755 0 0 1-.101-.347c-.008-.95-.007-1.901-.003-2.852a.658.658 0 0 1 .664-.662c.37 0 .658.283.663.662.005.475 0 .95 0 1.426z" />
                                        </svg>
                                      </span>
                                    </span>
                                  </div>
                                </div>
                                <div className={styles.listGenre}>{game.genre}</div>
                              </div>
                            </div>
                            <button
                              type="button"
                              className={styles.activeArrow}
                              aria-label={`Open ${game.name}`}
                              onClick={e => {
                                e.stopPropagation();
                                goToGame(game);
                              }}
                              onKeyDown={e => {
                                if (e.key !== "Enter") return;
                                e.stopPropagation();
                                goToGame(game);
                              }}
                            >
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                              >
                                <path d="M9 18l6-6-6-6" />
                              </svg>
                            </button>
                          </div>
                        ))}
                      </div>
                      {/* 過罩固定在 featuredGrid 内部，不随列表滚动 */}
                      <div className={styles.featuredListBottomMask}></div>
                    </div>
                  </section>
                ) : (
                  // Category Header View
                  <section className={styles.categoryHeaderSection}>
                    {/* 1. Category Pills (Scrollable) */}
                    <div className={styles.categoryPillsContainer}>
                      {categories.map(cat => {
                        const id = cat.categoryId ?? cat.categoryName ?? "";
                        const isActive = activeCategory === id;
                        return (
                          <button
                            key={id}
                            className={`${styles.categoryPill} ${isActive ? styles.categoryPillActive : ""}`}
                            onClick={() => setActiveCategory(id)}
                          >
                            {cat.categoryName}
                          </button>
                        );
                      })}
                    </div>
                    {/* 2. Category Title & Description */}
                    {(() => {
                      const activeCatObj = categories.find(
                        cat =>
                          (cat.categoryId ?? cat.categoryName) ===
                          activeCategory,
                      );
                      const title =
                        activeCatObj?.categoryName || t("home.category.default", "Category");
                      return (
                        <div className={styles.categoryInfoArea}>
                          <p className={styles.categoryTitle}>{title}</p>
                          <p className={styles.categoryDescription}>
                            <TextWithGameeBrand
                              text={t(
                                "home.category.description",
                                "Explore the top {title} games for Android/iOS on Gamee. Download free, virus-free games, read reviews, and share your own experiences.",
                                { title: title.toLowerCase() },
                              )}
                            />
                          </p>
                        </div>
                      );
                    })()}
                  </section>
                )}
                <section className={styles.section}>
                  {!activeCategory && (
                    <div className={styles.sectionTitle}>
                      {t("home.trending.title", "Trending Games")}
                    </div>
                  )}
                  {/* <p className={styles.sectionSubtitle}>
                Based on player counts and ratings
              </p> */}
                  <div className={styles.trendingRow}>
                    {trendingGames.map(game => (
                      <div
                        key={game.id}
                        className={styles.trendingCard}
                        onClick={() => goToGame(game)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={e => e.key === "Enter" && goToGame(game)}
                      >
                        {/* Card Image Section */}
                        <div className={styles.trendingCardImageWrapper}>
                          {game.cover ? (
                            <img
                              src={game.cover}
                              alt={game.name}
                              className={styles.trendingCardImg}
                            />
                          ) : game.iconId ? null : (
                            <div className={styles.trendingCardPlaceholder}>
                              {game.name?.charAt(0) || "G"}
                            </div>
                          )}
                          {/* Optional duration badge mock */}
                          <div className={styles.durationBadge}></div>
                        </div>

                        {/* Card Body Section */}
                        <div className={styles.trendingCardBody}>
                          <div className={styles.trendingCardHeader}>
                            <h4 className={styles.trendingCardTitle}>
                              {game.name}
                            </h4>
                            <div className={styles.trendingRatingContainer}>
                              <span className={styles.trendingRatingLabel}>
                                <GameeBrand />
                              </span>
                              <span className={styles.trendingRatingValue}>
                                {formatRating(game.rating)}
                              </span>
                            </div>
                          </div>

                          <div className={styles.trendingCardMeta}>
                            {game.genre || ""}
                            <span
                              className={styles.platformIcon}
                              title="Android"
                              aria-label={t("aria.android", "Android")}
                            >
                              <svg
                                className={styles.platformSvg}
                                viewBox="0 0 12 12"
                                aria-hidden="true"
                              >
                                <path d="M2.834 3.875h6.214v4.781c0 .523-.28.799-.804.8H7.86c0 .553.006 1.091-.002 1.63a.652.652 0 0 1-.624.622c-.355.013-.68-.233-.692-.574-.02-.55-.006-1.103-.006-1.667h-1.19v.657c-.002.323.005.646-.006.969a.649.649 0 0 1-.566.612.664.664 0 0 1-.725-.454.737.737 0 0 1-.034-.213c-.003-.459-.002-.917-.001-1.376 0-.063.01-.126.018-.207h-.457c-.449-.003-.74-.294-.741-.744V3.876zm6.217-.458H2.83c.058-1.076.67-1.745 1.577-2.22L4.134.786 3.936.488c-.046-.07-.12-.15-.017-.22.11-.074.155.031.204.103.117.172.232.345.347.518.142.214.142.214.387.142a3.74 3.74 0 0 1 2.315.05c.028.01.056.017.092.028L7.738.4l.056-.084c.045-.064.101-.098.172-.046.064.048.053.108.013.169l-.41.614-.095.145c.904.47 1.52 1.14 1.577 2.22zm-1.446-1.21a.337.337 0 0 0-.33-.335.33.33 0 0 0-.333.329.324.324 0 0 0 .327.332.33.33 0 0 0 .336-.326zm-2.667-.008a.33.33 0 0 0-.335-.327.338.338 0 0 0-.327.337.331.331 0 0 0 .337.324.324.324 0 0 0 .325-.334zm5.884 3.76v1.387c-.002.407-.282.701-.664.7-.382 0-.665-.295-.665-.7 0-.938-.002-1.875 0-2.813a.655.655 0 0 1 .588-.657.658.658 0 0 1 .726.518c.014.066.014.135.014.203v1.362zm-8.437 0c0 .484.004.967-.002 1.451a.652.652 0 0 1-.497.619.649.649 0 0 1-.724-.297.755.755 0 0 1-.101-.347c-.008-.95-.007-1.901-.003-2.852a.658.658 0 0 1 .664-.662c.37 0 .658.283.663.662.005.475 0 .95 0 1.426z" />
                              </svg>
                            </span>
                          </div>

                          {(() => {
                            const raw =
                              game.description && game.description.trim()
                                ? String(game.description).trim()
                                : "";
                            const fallback = t(
                              "home.trending.discussion",
                              "Join the discussion on Gamee",
                            );
                            const displayPlain = !raw;
                            const titleText = displayPlain
                              ? fallback
                              : stripHtml(raw);
                            return (
                              <p
                                className={styles.trendingCardDesc}
                                title={titleText}
                              >
                                <span className={styles.commentIcon}>💬</span>{" "}
                                {displayPlain ? (
                                  <TextWithGameeBrand text={fallback} />
                                ) : (
                                  <span
                                    className={styles.trendingCardDescHtml}
                                    dangerouslySetInnerHTML={{ __html: raw }}
                                  />
                                )}
                              </p>
                            );
                          })()}

                          <div className={styles.trendingRank}>
                            <span className={styles.rankIcon}>
                              {t("home.rank.top", "TOP")}
                            </span>{" "}
                            {game.topComment && String(game.topComment).trim() ? (
                              <span
                                className={styles.trendingRankContent}
                                dangerouslySetInnerHTML={{
                                  __html: String(game.topComment).trim(),
                                }}
                              />
                            ) : (
                              t(
                                "home.trending.defaultTopComment",
                                "Trending in Android Popular Chart.",
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                    {trendingListSettled &&
                      !trendingLoading &&
                      trendingGames.length === 0 && (
                        <div
                          className={styles.trendingRowEmpty}
                          role="status"
                          aria-live="polite"
                        >
                          <p className={styles.trendingRowEmptyText}>
                            {trendingError
                              ? t(
                                  "home.trending.loadError",
                                  "Couldn't load trending games. Check your connection and try again.",
                                )
                              : t("home.trending.empty", "No games to show here yet.")}
                          </p>
                        </div>
                      )}
                  </div>

                  {/* 加载状态指示器 */}
                  {trendingLoading && (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "var(--theme-text-muted, #999)",
                      }}
                    >
                      ...
                    </div>
                  )}

                  {/* 没有更多数据提示 */}
                  {!trendingHasMore && trendingGames.length > 0 && (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "var(--theme-text-muted, #ccc)",
                      }}
                    >
                      {t("home.trending.noMore", "no more games")}
                    </div>
                  )}
                </section>
              </>
            )}
          </main>
        </div>
      </div>

      {/* Mobile Search Overlay */}
      <AnimatePresence>
        {isMobileSearchOpen && (
          <motion.div
            className={styles.mobileSearchOverlay}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.2 }}
          >
            <div className={styles.mobileSearchHeader}>
              <button
                className={styles.mobileBackBtn}
                onClick={() => setIsMobileSearchOpen(false)}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M19 12H5M12 19l-7-7 7-7" />
                </svg>
              </button>
              <form
                className={styles.mobileSearchForm}
                onSubmit={handleSearchSubmit}
              >
                <select
                  className={styles.searchTypeSelectMobile}
                  value={searchType}
                  onChange={e => setSearchType(e.target.value)}
                  aria-label={t("home.search.type.aria", "Search Type (Games, Topics, Collections)")}
                >
                  <option value="1">{t("home.search.type.games", "Games")}</option>
                  <option value="2">{t("home.search.type.topics", "Topics")}</option>
                  <option value="4">{t("home.search.type.collections", "Collections")}</option>
                </select>
                <div className={styles.mobileSearchInputWrapper}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#999"
                    strokeWidth="2"
                  >
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                  <input
                    autoFocus
                    type="search"
                    placeholder={t("home.search.mobilePlaceholder", "Search")}
                    value={searchInput}
                    onChange={e => {
                      const val = e.target.value;
                      setSearchInput(val);
                      // 在合集页清空搜索框时，同步清除关键词以重置列表
                      if (!val && isCollectionsPage) {
                        setCollectionSearchKeyword("");
                      }
                    }}
                    className={styles.mobileSearchInput}
                  />
                  {searchInput && (
                    <button
                      type="button"
                      className={styles.mobileClearBtn}
                      onClick={() => setSearchInput("")}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                    </button>
                  )}
                </div>
                <button type="submit" className={styles.mobileSearchActionBtn}>
                  {t("home.search.action", "Search")}
                </button>
              </form>
            </div>

            {(searchList.length > 0 || searchListLoading || searchEmptyHintVisible) && (
              <div className={styles.mobileSearchList}>
                {searchListLoading && searchList.length === 0 ? (
                  <div className={styles.searchDropdownItem}>
                    {t("home.search.searching", "Searching...")}
                  </div>
                ) : searchList.length === 0 && searchEmptyHintVisible ? (
                  <div className={styles.searchDropdownItem}>
                    {t("home.search.noResult", "No results found")}
                  </div>
                ) : (
                  searchList.map(item => (
                    <button
                      key={item.objectId}
                      type="button"
                      className={styles.searchDropdownItem}
                      onClick={() => handleSelectSearchItem(item)}
                    >
                      {item.objectName}
                    </button>
                  ))
                )}
              </div>
            )}

            <div className={styles.mobileSearchContent}>
              <h3 className={styles.trendingTitle}>{t("home.mobile.trending", "Trending")}</h3>
              <div className={styles.trendingList}>
                {games.slice(0, 10).map((game, index) => (
                  <div
                    key={game.id}
                    className={styles.trendingItem}
                    onClick={() => goToGame(game)}
                  >
                    <span
                      className={`${styles.trendingIndex} ${index < 3 ? styles.top3 : ""}`}
                    >
                      {index + 1}
                    </span>
                    <img
                      src={game.cover}
                      alt={game.name}
                      className={styles.trendingCover}
                    />
                    <div className={styles.trendingInfo}>
                      <div className={styles.trendingName}>{game.name}</div>
                      <div className={styles.trendingMeta}>
                        <span className={styles.starIcon}>★</span>{" "}
                        {formatRating(game.rating)} • {game.surname}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        )}

        {activeNotification && (
          <div
            className={styles.notificationModalOverlay}
            onClick={() => setActiveNotification(null)}
          >
            <div
              className={styles.notificationModal}
              onClick={e => e.stopPropagation()}
            >
              <button
                className={styles.notificationModalClose}
                onClick={() => setActiveNotification(null)}
              >
                ✕
              </button>
              <div className={styles.notificationModalTitle}>
                {activeNotification.title ||
                  t("home.notifications.system", "System Notification")}
              </div>
              <div className={styles.notificationModalMeta}>
                {activeNotification.sendTime || ""}
              </div>
              {activeNotification.content && (
                <div
                  className={styles.notificationModalContent}
                  dangerouslySetInnerHTML={{
                    __html: String(activeNotification.content),
                  }}
                />
              )}
            </div>
          </div>
        )}
      </AnimatePresence>
      <AppDownloadModal
        open={modalOpen}
        loading={modalInfo.loading}
        previewUrl={modalInfo.previewUrl}
        versionName={modalInfo.versionName}
        description={modalInfo.description}
        downloading={downloadLoading}
        onClose={closeDownloadModal}
        onDownload={startDownload}
      />
      <DownloadProgress
        open={downloadProgress.open}
        minimized={downloadProgress.minimized}
        phase={downloadProgress.phase}
        percent={downloadProgress.percent}
        onMinimize={minimizeDownload}
        onExpand={expandDownload}
      />
    </div>
  );
};

export default Home;
